import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { PageLoader } from '~/components/page/PageLoader';

export default function LimeRoute() {
  useBreadcrumb('routes/lime', 'Lime');
  return <PageLoader pageName="lime" />;
}
